<template>
  <rect
    width="63.8146"
    height="79.963"
    rx="2"
    transform="matrix(0.86513 0.501547 -0.498454 0.866916 57.8027 9)"
    fill="#DAE5F5"
  />
  <rect
    x="0.353982"
    y="0.613119"
    width="62.7575"
    height="79.0341"
    rx="1.5"
    transform="matrix(0.965609 0.259999 -0.257644 0.96624 45.1819 12.6533)"
    fill="#A3B1D1"
    stroke="#8497C2"
  />
  <rect
    x="29.9189"
    y="22.0098"
    width="63.7366"
    height="80.0601"
    rx="2"
    fill="white"
  />
  <path
    d="M68.7578 85.0574C68.7578 84.5047 69.2059 84.0566 69.7586 84.0566H81.2015C81.7542 84.0566 82.2023 84.5047 82.2023 85.0574C82.2023 85.6101 81.7542 86.0581 81.2015 86.0581H69.7586C69.2059 86.0581 68.7578 85.6101 68.7578 85.0574Z"
    fill="#A3B1D1"
  />
  <circle
    cx="62"
    cy="50.5"
    r="13.2805"
    stroke="#EBEEF5"
    stroke-width="6.43902"
  />
  <mask id="path-6-inside-1_871_15615" fill="white">
    <path
      d="M45.5 50.5C45.5 52.6668 45.9268 54.8124 46.756 56.8143C47.5852 58.8161 48.8006 60.6351 50.3327 62.1673C51.8649 63.6994 53.6839 64.9148 55.6857 65.744C57.6876 66.5732 59.8332 67 62 67L62 60.5619C60.6787 60.5619 59.3702 60.3017 58.1495 59.796C56.9287 59.2903 55.8195 58.5492 54.8852 57.6148C53.9508 56.6805 53.2097 55.5713 52.704 54.3505C52.1983 53.1298 51.9381 51.8213 51.9381 50.5L45.5 50.5Z"
    />
  </mask>
  <path
    d="M45.5 50.5C45.5 52.6668 45.9268 54.8124 46.756 56.8143C47.5852 58.8161 48.8006 60.6351 50.3327 62.1673C51.8649 63.6994 53.6839 64.9148 55.6857 65.744C57.6876 66.5732 59.8332 67 62 67L62 60.5619C60.6787 60.5619 59.3702 60.3017 58.1495 59.796C56.9287 59.2903 55.8195 58.5492 54.8852 57.6148C53.9508 56.6805 53.2097 55.5713 52.704 54.3505C52.1983 53.1298 51.9381 51.8213 51.9381 50.5L45.5 50.5Z"
    stroke="#E2E6F0"
    stroke-width="12.878"
    mask="url(#path-6-inside-1_871_15615)"
  />
  <mask id="path-7-inside-2_871_15615" fill="white">
    <path
      d="M78.5 50.5C78.5 48.3332 78.0732 46.1876 77.244 44.1857C76.4148 42.1839 75.1994 40.3649 73.6673 38.8327C72.1351 37.3006 70.3161 36.0852 68.3143 35.256C66.3124 34.4268 64.1668 34 62 34V40.4381C63.3213 40.4381 64.6298 40.6983 65.8505 41.204C67.0713 41.7097 68.1805 42.4508 69.1148 43.3852C70.0492 44.3195 70.7903 45.4287 71.296 46.6495C71.8017 47.8702 72.0619 49.1787 72.0619 50.5H78.5Z"
    />
  </mask>
  <path
    d="M78.5 50.5C78.5 48.3332 78.0732 46.1876 77.244 44.1857C76.4148 42.1839 75.1994 40.3649 73.6673 38.8327C72.1351 37.3006 70.3161 36.0852 68.3143 35.256C66.3124 34.4268 64.1668 34 62 34V40.4381C63.3213 40.4381 64.6298 40.6983 65.8505 41.204C67.0713 41.7097 68.1805 42.4508 69.1148 43.3852C70.0492 44.3195 70.7903 45.4287 71.296 46.6495C71.8017 47.8702 72.0619 49.1787 72.0619 50.5H78.5Z"
    stroke="#E2E6F0"
    stroke-width="12.878"
    mask="url(#path-7-inside-2_871_15615)"
  />
  <mask id="path-8-inside-3_871_15615" fill="white">
    <path
      d="M77.7 55.5755C78.503 53.0914 78.7052 50.4523 78.2898 47.8749C77.8745 45.2976 76.8535 42.8556 75.3108 40.7495C73.7681 38.6435 71.7477 36.9336 69.4156 35.7603C67.0835 34.587 64.5063 33.9838 61.8957 34.0003L61.9364 40.4383C63.5284 40.4282 65.1 40.7961 66.5221 41.5115C67.9443 42.227 69.1764 43.2698 70.1171 44.554C71.0579 45.8383 71.6805 47.3275 71.9338 48.8992C72.187 50.4709 72.0638 52.0803 71.5741 53.5951L77.7 55.5755Z"
    />
  </mask>
  <path
    d="M77.7 55.5755C78.503 53.0914 78.7052 50.4523 78.2898 47.8749C77.8745 45.2976 76.8535 42.8556 75.3108 40.7495C73.7681 38.6435 71.7477 36.9336 69.4156 35.7603C67.0835 34.587 64.5063 33.9838 61.8957 34.0003L61.9364 40.4383C63.5284 40.4282 65.1 40.7961 66.5221 41.5115C67.9443 42.227 69.1764 43.2698 70.1171 44.554C71.0579 45.8383 71.6805 47.3275 71.9338 48.8992C72.187 50.4709 72.0638 52.0803 71.5741 53.5951L77.7 55.5755Z"
    stroke="#8497C2"
    stroke-width="12.878"
    mask="url(#path-8-inside-3_871_15615)"
  />
  <mask id="path-9-inside-4_871_15615" fill="white">
    <path
      d="M71.6088 63.9135C74.5483 61.8077 76.7148 58.7946 77.7749 55.3375L71.6198 53.45C70.9733 55.5582 69.6521 57.3956 67.8595 58.6797L71.6088 63.9135Z"
    />
  </mask>
  <path
    d="M71.6088 63.9135C74.5483 61.8077 76.7148 58.7946 77.7749 55.3375L71.6198 53.45C70.9733 55.5582 69.6521 57.3956 67.8595 58.6797L71.6088 63.9135Z"
    stroke="#A3B1D1"
    stroke-width="12.878"
    mask="url(#path-9-inside-4_871_15615)"
  />
  <path
    d="M49.4746 39.7592C46.8472 42.8231 45.434 46.7438 45.5024 50.7794C45.5707 54.8151 47.1159 58.6857 49.8456 61.6589C52.5752 64.6321 56.3 66.5016 60.3151 66.9137C64.3302 67.3259 68.3572 66.2521 71.6339 63.8954L67.8749 58.6687C65.8767 60.1058 63.421 60.7607 60.9725 60.5093C58.5241 60.258 56.2527 59.1179 54.5881 57.3048C52.9235 55.4917 51.9812 53.1314 51.9395 50.6704C51.8978 48.2094 52.7597 45.8185 54.3619 43.9501L49.4746 39.7592Z"
    fill="#8497C2"
  />
  <mask id="path-11-inside-5_871_15615" fill="white">
    <path
      d="M54.1457 35.9893C52.0371 37.1307 50.2025 38.7179 48.7698 40.6404C47.337 42.563 46.3405 44.7747 45.8496 47.1216L52.1513 48.4398C52.4506 47.0086 53.0583 45.6599 53.9321 44.4875C54.8058 43.3151 55.9245 42.3472 57.2104 41.6512L54.1457 35.9893Z"
    />
  </mask>
  <path
    d="M54.1457 35.9893C52.0371 37.1307 50.2025 38.7179 48.7698 40.6404C47.337 42.563 46.3405 44.7747 45.8496 47.1216L52.1513 48.4398C52.4506 47.0086 53.0583 45.6599 53.9321 44.4875C54.8058 43.3151 55.9245 42.3472 57.2104 41.6512L54.1457 35.9893Z"
    stroke="#A3B1D1"
    stroke-width="12.878"
    mask="url(#path-11-inside-5_871_15615)"
  />
  <mask id="path-12-inside-6_871_15615" fill="white">
    <path
      d="M62 34C59.2543 34 56.552 34.6852 54.138 35.9935L57.2056 41.6538C58.6777 40.8559 60.3256 40.4381 62 40.4381V34Z"
    />
  </mask>
  <path
    d="M62 34C59.2543 34 56.552 34.6852 54.138 35.9935L57.2056 41.6538C58.6777 40.8559 60.3256 40.4381 62 40.4381V34Z"
    stroke="#DAE5F5"
    stroke-width="12.878"
    mask="url(#path-12-inside-6_871_15615)"
  />
  <circle
    opacity="0.06"
    cx="61.9992"
    cy="50.4992"
    r="10.7049"
    stroke="black"
    stroke-width="1.2878"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M49.0731 79.0572C48.594 79.3352 47.9802 79.1707 47.7042 78.6904L47.6296 78.5604C47.2451 77.8913 46.2798 77.8913 45.8954 78.5604L45.8204 78.6909C45.5445 79.1712 44.9307 79.3357 44.4515 79.0577L44.3239 78.9836C43.6572 78.5968 42.822 79.0778 42.822 79.8486V80.0104C42.822 80.5626 42.3743 81.0104 41.822 81.0104H41.6651C40.8963 81.0104 40.415 81.8419 40.7981 82.5085L40.8836 82.6573C41.1579 83.1348 40.9946 83.7441 40.5183 84.0205L40.3722 84.1052C39.708 84.4906 39.708 85.4498 40.3722 85.8352L40.5185 85.9201C40.9948 86.1964 41.1581 86.8058 40.8838 87.2832L40.7979 87.4326C40.4149 88.0993 40.8962 88.9308 41.665 88.9308H41.822C42.3743 88.9308 42.822 89.3785 42.822 89.9308V90.0933C42.822 90.8641 43.6572 91.3451 44.3238 90.9583L44.4519 90.884C44.9311 90.606 45.5449 90.7705 45.8209 91.2508L45.8955 91.3807C46.28 92.0499 47.2453 92.0499 47.6297 91.3807L47.7047 91.2503C47.9806 90.77 48.5944 90.6055 49.0736 90.8835L49.2013 90.9576C49.8679 91.3443 50.7031 90.8633 50.7031 90.0926V89.9308C50.7031 89.3785 51.1508 88.9308 51.7031 88.9308H51.86C52.6288 88.9308 53.1101 88.0993 52.727 87.4326L52.6415 87.2838C52.3672 86.8064 52.5305 86.197 53.0068 85.9207L53.1529 85.8359C53.8171 85.4506 53.8171 84.4914 53.1529 84.106L53.0066 84.0211C52.5303 83.7448 52.367 83.1354 52.6413 82.6579L52.7271 82.5085C53.1102 81.8419 52.6289 81.0104 51.8601 81.0104H51.7031C51.1508 81.0104 50.7031 80.5626 50.7031 80.0104V79.8478C50.7031 79.0771 49.8679 78.5961 49.2013 78.9829L49.0731 79.0572ZM46.7625 89.1142C49.0328 89.1142 50.8815 87.2635 50.8815 84.9702C50.8815 82.6769 49.0328 80.8262 46.7625 80.8262C44.4923 80.8262 42.6435 82.6769 42.6435 84.9702C42.6435 87.2635 44.4923 89.1142 46.7625 89.1142ZM46.7625 90.1142C49.5897 90.1142 51.8815 87.8112 51.8815 84.9702C51.8815 82.1293 49.5897 79.8262 46.7625 79.8262C43.9354 79.8262 41.6435 82.1293 41.6435 84.9702C41.6435 87.8112 43.9354 90.1142 46.7625 90.1142ZM48.836 85.0565C48.836 86.1669 47.9415 87.0588 46.8483 87.0588C45.7552 87.0588 44.8607 86.1669 44.8607 85.0565C44.8607 83.9461 45.7552 83.0543 46.8483 83.0543C47.9415 83.0543 48.836 83.9461 48.836 85.0565ZM49.836 85.0565C49.836 86.7146 48.4984 88.0588 46.8483 88.0588C45.1983 88.0588 43.8607 86.7146 43.8607 85.0565C43.8607 83.3984 45.1983 82.0543 46.8483 82.0543C48.4984 82.0543 49.836 83.3984 49.836 85.0565Z"
    fill="#DAE5F5"
  />
  <path
    d="M10.0518 43.5801L11.0431 44.6458C11.4193 45.0502 12.052 45.0731 12.4564 44.6969L15.6699 41.7077C16.0743 41.3316 16.0971 40.6988 15.721 40.2945L14.7296 39.2287"
    stroke="#DAE5F5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M20.0225 104.414L19.2947 105.675C19.0186 106.153 19.1824 106.764 19.6607 107.041L23.4615 109.235C23.9398 109.511 24.5514 109.347 24.8276 108.869L25.5553 107.608"
    stroke="#D0D7E7"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M102.228 13L101.5 14.2605C101.224 14.7388 101.388 15.3504 101.866 15.6265L105.667 17.8209C106.145 18.0971 106.757 17.9332 107.033 17.4549L107.76 16.1944"
    stroke="#DAE5F5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</template>
